import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export default class NullToFalseBooleanConverter implements JsonCustomConvert<boolean> {
  public serialize(val: boolean): any {
    return val;
  }

  public deserialize(val: unknown): boolean {
    if (val === null || val === undefined) return false;

    return Boolean(val);
  }
}
